import { render, staticRenderFns } from "./ManageSlideDeck.modal.vue?vue&type=template&id=197ed2d2"
import script from "./ManageSlideDeck.modal.vue?vue&type=script&lang=ts"
export * from "./ManageSlideDeck.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageSlideDeck.modal.vue?vue&type=style&index=0&id=197ed2d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports